import { DEFAULT_FONT } from "views/public/link-hub/fonts";

// Tenant palette values rendered on the public Link Hub. These are data, not app chrome.
export const PRESET_COLORS = [
  { name: "Light Cream", value: "#F5F2E9" },
  { name: "Pure White", value: "#FFFFFF" },
  { name: "Soft Blue", value: "#E8F4F8" },
  { name: "Mint Green", value: "#E8F8F5" },
  { name: "Lavender", value: "#F3E8F8" },
  { name: "Peach", value: "#FFF0E8" },
  { name: "Light Gray", value: "#F5F5F5" },
  { name: "Soft Pink", value: "#FCE8F3" },
];

export const BUTTON_STYLES = [
  { name: "Rounded", value: "rounded", radius: "0.75rem" },
  { name: "Pill", value: "pill", radius: "9999px" },
  { name: "Square", value: "square", radius: "0.25rem" },
];

export const ACTION_BUTTONS = [
  { id: "visitor", label: "I'm New Here", description: "Visitor connection form" },
  { id: "prayer", label: "Submit Prayer Request", description: "Prayer request form" },
  { id: "giving", label: "Give", description: "Donation form" },
];

export const DEFAULT_BUTTON_ORDER = ["visitor", "prayer", "giving"];

export const DEFAULT_BUTTON_SETTINGS = {
  visitor: { visible: true, text: "I'm New Here", color: "#FFFFFF" },
  prayer: { visible: true, text: "Submit Prayer Request", color: "#FFFFFF" },
  // An empty color makes the giving button fall back to buttonColor.
  giving: { visible: true, text: "Give", color: "" },
};

const DEFAULT_COLORS = {
  backgroundColor: "#F5F2E9",
  displayNameColor: "#000000",
  taglineColor: "#6B7280",
  buttonColor: "#4F9A85",
  actionButton: "#FFFFFF",
};

export const DEFAULT_FORM = {
  displayName: "",
  tagline: "",
  logoUrl: "",
  backgroundColor: DEFAULT_COLORS.backgroundColor,
  displayNameColor: DEFAULT_COLORS.displayNameColor,
  taglineColor: DEFAULT_COLORS.taglineColor,
  givingButtonText: "Give",
  notifyOnVisitor: true,
  notifyOnPrayer: true,
  notifyOnDonation: true,
  notificationEmail: "",
  headingFont: DEFAULT_FONT,
  bodyFont: DEFAULT_FONT,
  buttonStyle: "rounded",
  buttonColor: DEFAULT_COLORS.buttonColor,
  buttonOrder: DEFAULT_BUTTON_ORDER,
  buttonSettings: DEFAULT_BUTTON_SETTINGS,
};

export const profileToForm = (profile) => ({
  displayName: profile.displayName || "",
  tagline: profile.tagline || "",
  logoUrl: profile.logoUrl || "",
  backgroundColor: profile.backgroundColor || DEFAULT_FORM.backgroundColor,
  displayNameColor: profile.displayNameColor || DEFAULT_FORM.displayNameColor,
  taglineColor: profile.taglineColor || DEFAULT_FORM.taglineColor,
  givingButtonText: profile.givingButtonText || DEFAULT_FORM.givingButtonText,
  notifyOnVisitor: profile.notifyOnVisitor !== false,
  notifyOnPrayer: profile.notifyOnPrayer !== false,
  notifyOnDonation: profile.notifyOnDonation !== false,
  notificationEmail: profile.notificationEmail || "",
  headingFont: profile.headingFont || DEFAULT_FORM.headingFont,
  bodyFont: profile.bodyFont || DEFAULT_FORM.bodyFont,
  buttonStyle: profile.buttonStyle || DEFAULT_FORM.buttonStyle,
  buttonColor: profile.buttonColor || DEFAULT_FORM.buttonColor,
  buttonOrder: profile.buttonOrder || DEFAULT_BUTTON_ORDER,
  buttonSettings: profile.buttonSettings || DEFAULT_BUTTON_SETTINGS,
});

export const linkButtonId = (link) => `link_${link.id}`;

export const isLinkButtonId = (buttonId) => buttonId.startsWith("link_");

export const findLink = (links, buttonId) => {
  const linkId = buttonId.replace("link_", "");
  return links.find((l) => String(l.id) === linkId);
};

export const getButtonText = (buttonSettings, buttonId) =>
  buttonSettings?.[buttonId]?.text || DEFAULT_BUTTON_SETTINGS[buttonId]?.text || "";

export const getButtonBgColor = (buttonSettings, buttonColor, buttonId) => {
  const saved = buttonSettings?.[buttonId]?.color;
  if (saved) return saved;
  if (buttonId === "giving") return buttonColor;
  return DEFAULT_COLORS.actionButton;
};

export const isButtonVisible = (buttonSettings, buttonId) =>
  buttonSettings?.[buttonId]?.visible !== false;

export const getButtonRadius = (style) =>
  BUTTON_STYLES.find((s) => s.value === style)?.radius || "0.75rem";

// Light or dark text for a tenant button background.
export const getContrastText = (bgHex) => {
  const hex = (bgHex || "#FFFFFF").replace("#", "");
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return luminance > 0.55 ? "#1a1a1a" : "#ffffff";
};
